export default "__VITE_ASSET__lxx_SGso__"